import React from 'react';
import { Typography } from 'antd';
import cn from 'classnames';
import styles from './DateCellContent.module.scss';

const { Text } = Typography;

const DateCellContent = ({ date, onClick, ...props }) => {
  return (
    <div
      {...props}
      onClick={onClick}
      className={cn(styles.root, {
        [styles.isActive]: typeof onClick === 'function',
      })}
    >
      {date ? (
        <div className={styles.dateBlock}>
          <Text className={styles.text}>{date.format('DD.MM.YYYY')}</Text>
          <Text className={styles.text}>{date.format('HH:mm')}</Text>
        </div>
      ) : (
        <Text className={styles.text}>Не указано</Text>
      )}
    </div>
  );
};

export default DateCellContent;
